import { UsuarioPersonal } from './../../projects/personal/accesos/accesos-class/accesos.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SystemServiceService } from 'src/app/services/system-service.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { SetCurrentModuleAction } from 'src/app/shared/redux/modules.actions';
import { ActivarLoadingAction, DesactivarLoadingAction } from 'src/app/shared/redux/loading.actions';
import { Parent } from 'src/app/shared/class/parent.model';

@Component({
	selector: 'sipac-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends Parent implements OnInit, OnDestroy {
	public menu = []
	public uid = '';
	public bgClass = ['bg-cyan', 'bg-success', 'bg-info', 'bg-danger', 'bg-warning']
	constructor(
		private systemService: SystemServiceService,
		private router: Router,
		private store: Store<AppState>
	) {
		super();
		this.usuario = <UsuarioPersonal>JSON.parse(sessionStorage.getItem('usuario'));
	}

	ngOnInit() {
		this.store.dispatch(new SetCurrentModuleAction(null));
		this.store.dispatch(new ActivarLoadingAction());
		this.systemService.getModules().subscribe((data: any[]) => {
			if (data['success']) {
				this.menu = data['data'];
				if (this.usuario.modulo !== 'SUPERUSUARIO') {
					console.log(this.usuario.modulo);
					this.menu = this.menu.filter(x => x.mn_cod.toUpperCase() === this.usuario.modulo);
					console.log(this.menu);
				}
			}
			this.store.dispatch(new DesactivarLoadingAction());
		});
	}

	open_menu(item: any[]) {
		/* this.router.navigate(['home'+item['mn_path']]); */
		this.router.navigateByUrl('home' + item['mn_path']);
		this.store.dispatch(new SetCurrentModuleAction(item['mn_cod']));
	}

	ngOnDestroy() {
	}

}
